import { Box } from '@mantine/core';

import { useGetManagersReplies } from '..';
import { ManagerRepliesChart } from '../components/Managers/RepliesChart';
import { ManagerRepliesFilter } from '../components/Managers/RepliesFilter';
import { useManagerRepliesForm } from '../hooks/useManagerRepliesFilter';

export const Managers = () => {
  const form = useManagerRepliesForm();

  const {
    data: { data, series },
    isError,
    isFetching,
    isFetched,
    refetch,
  } = useGetManagersReplies({ filter: form.values });

  return (
    <Box>
      <ManagerRepliesFilter form={form} onSubmit={refetch} />
      <ManagerRepliesChart
        data={data}
        series={series}
        isError={isError}
        isLoading={isFetching}
        isFetched={isFetched}
      />
    </Box>
  );
};
